import React, { useState, useRef } from "react";

// import VendorList from "./VendorList";
import { Link } from "react-router-dom";
// import Addingemployees from "./Addingemployees";
import Eventbillingandsetup from "./Eventbillingandsetup";

const Eventsetingspage = () => {
    const [activeTab, setActiveTab] = useState("Billing Setup");

    const tabContent = {
        // Employee: <Addingemployees />,
        "Billing Setup": <Eventbillingandsetup />,
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-2"></div>
                <div className="col-lg-10 settings-and-controllers-data" style={{ height: "80vh", overflowY: "auto", scrollbarWidth: "none" }}>
                    <p
                        className="breadcrumb maamaas-home-bredcum or7"
                        style={{
                            position: "fixed",
                            top: "59px",
                            left: "1vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            padding: "10px 0",
                            fontSize: "18px",
                            fontWeight: "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        <Link
                            to="/Homes"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link>

                        <span className="separator"> &gt; </span>


                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Settings_Controls
                        </span>
                        <span className="separator"> &gt; </span>


                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Events
                        </span>

                    </p>
                    <div className="discount-container">
                        {/* Responsive, centered tab buttons */}
                        <div


                            // style={{
                            //     display: "flex",
                            //     justifyContent: "center",
                            //     alignItems: "center",
                            //     position: "fixed",
                            //     top: "158px",
                            //     left: "50%",
                            //     transform: "translate(-45%, -50%)",
                            //     gap: "10px",
                            //     width: "90vw",
                            //     maxWidth: "600px",
                            //     flexWrap: "wrap",
                            //     padding: "10px 0",
                            // }}


                            className="rorr row b2"
                           >


                            {/* {Object.keys(tabContent).map((label) => (
                                <div
                                    key={label}
                                    className="col-lg-3 col-md-6 col-sm-12 col-12"
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        marginBottom: "10px",
                                        minWidth: "150px",
                                    }}
                                  >
                                    <button
                                        onClick={() => setActiveTab(label)}
                                        style={{
                                            border: "none",
                                            borderRadius: "10px",
                                            minWidth: "140px",
                                            width: "100%",
                                            padding: "0 10px",
                                            height: "40px",
                                            backgroundColor: activeTab === label ? "#b15cd6" : "#d9d9d9",
                                            color: activeTab === label ? "#fff" : "#000",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            transition: "background-color 0.3s ease",
                                            fontSize: "1rem",
                                        }}
                                    >
                                        {label}
                                    </button>
                                </div>
                            ))} */}


                        </div>
                        {/* Tab Content - Scrollable Part */}
                        <div
                            style={{
                                height: "77vh",
                                overflowY: "auto",
                                scrollbarWidth: "none",
                                paddingTop: "20px",
                                borderRadius: "8px",
                                marginTop: "0px",
                            }}
                            className="b1"
                        >
                            {tabContent[activeTab]}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};



export default Eventsetingspage;
